export enum AccountModalType {
    Basic = "basic",
    Information = "information",
    Confirmation = "confirmation",
}
